import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

interface GoldCoin {
  id: number;
  weight: number;
  price: number;
  makingCharge: number;
  quantity: number;
}

@Component({
  selector: 'app-gold-coins-review',
  templateUrl: './gold-coins-review.component.html',
  styleUrls: ['./gold-coins-review.component.scss']
})
export class GoldCoinsReviewComponent implements OnInit {

  constructor(private router: Router) {}

  selectedCoins: GoldCoin[] = [];

  totalWeight: number = 0;

  estimatedTotal: number = 0;

  makingCharges: number = 0;

  grandTotal: number = 0;

  ngOnInit(): void {

    const state = history.state;

    if (state && state.coins) {

      this.selectedCoins = state.coins;

      this.totalWeight = state.totalWeight;

      this.estimatedTotal = state.estimatedTotal;

      this.makingCharges = state.makingCharges;

      this.grandTotal = state.grandTotal;

    } else {

      // Refresh ayithe home ki vellipothundi
      this.router.navigate(['/gold-coins']);

    }

  }

  getTotalWeight(item: GoldCoin): number {

    return item.weight * item.quantity;

  }

  getTotalPrice(item: GoldCoin): number {

    return item.price * item.quantity;

  }

  calculateGrandTotal(): number {

    return this.estimatedTotal + this.makingCharges;

  }

  goBack(): void {

    window.history.back();

  }

  placeOrder(): void {

    console.log('Selected Coins');

    console.log(this.selectedCoins);

    console.log('Total Weight :', this.totalWeight);

    console.log('Gold Amount :', this.estimatedTotal);

    console.log('Making Charges :', this.makingCharges);

    console.log('Grand Total :', this.grandTotal);

    alert('Order Placed Successfully');

    // Future API call
    // this.http.post(...)

  }

}